import { render, staticRenderFns } from "./PaymentMilestones.vue?vue&type=template&id=7ad3287f&"
import script from "./PaymentMilestones.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PaymentMilestones.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports